import PricingSection from "../../components/marketing/PricingSection";

const PricingPage = () => {
  return (
    <main>
      <PricingSection />
    </main>
  );
};

export default PricingPage;